// Pregunta 2: ¿Tienes la financiación preaprobada?

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FINANCING_OPTIONS } from '../../../config/buyerProfileOptions';

export const FinancingStatusQuestion = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-white">
        {t('questions.financing.question')} <span className="text-red-400">*</span>
      </label>
      <p className="text-xs text-slate-400">
        {t('questions.financing.helper')}
      </p>

      <div className="space-y-2">
        {FINANCING_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
              value === option.value
                ? 'bg-amber-500/10 border-amber-500 text-white'
                : 'bg-slate-800/50 border-slate-700 text-slate-300 hover:border-slate-600'
            }`}
          >
            <input
              type="radio"
              name="financing_status"
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="w-4 h-4 text-amber-500 focus:ring-amber-500"
            />
            <span className="text-sm">{t(option.labelKey)}</span>
          </label>
        ))}
      </div>

      {error && (
        <p className="text-xs text-red-400 mt-1">{error}</p>
      )}
    </div>
  );
};

export default FinancingStatusQuestion;
